<template>
  <el-dialog
    v-loading="changing"
    class="radish-dia"
    :title="'修改公司:' + radish['公司']"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <p>如果没有想要的查询结果，请修改关键词重新搜索。</p>
    <p>
      <span class="redword">红色</span>表示公司在数据库中已存在，直接点击即可修改，<span class="blueword">蓝色</span
      >表示公司不存在，需先点击标签，填写字段新建公司，然后即会后台进行修改
    </p>
    <div style="display:flex;">
      <el-input v-model="apiSerchString" size="mini"></el-input>
      <el-button size="mini" type="primary" @click="qichachaSerch(apiSerchString)">搜索</el-button>
    </div>
    <span>你想找的是不是：</span>
    <div v-if="qichachaResult.length === 0" class="waring">根据当前公司未匹配到结果，请修改关键词或新建公司</div>
    <div>
      <el-tag
        v-for="tag in qichachaResult"
        :key="tag.value"
        size="mini"
        style="margin:0 4px 4px 0"
        :type="tag.type"
        :class="[checkedTag === tag.value ? 'company-tag-highlight' : '', 'dialog-company-tag']"
        @click.native="insertCompany(tag)"
        >{{ tag.value }}</el-tag
      >
    </div>
    <div v-if="chooseCompanyVisible" class="dialog-footer">
      <el-button size="mini" type="primary" @click="consfirmUpdateAllRadish">确认修改</el-button>
    </div>
    <div v-if="insertCompanyVisible">
      <div style="display:flex;margin-bottom:4px;">
        <span style="width:55px;">简称:</span>
        <el-input v-model="company.简称" size="mini" placeholder="请输入内容" @blur="duplicate"></el-input>
      </div>
      <div style="display:flex;">
        <span style="width:55px;">行业:</span>
        <el-select v-model="company.行业" filterable size="mini" placeholder="请选择">
          <el-option v-for="item in industryOption" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <div class="dialog-footer"><el-button size="mini" type="primary" @click="saveCompany">确认修改</el-button></div>
    </div>
    <div class="clear-float"></div>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      options: [],
      radish: '',
      qichachaResult: [],
      insertCompanyVisible: false,
      chooseCompanyVisible: false,
      company: { 公司名称: '', 简称: '', 行业: '' },
      industryOption: app.industries || [],
      couldInsert: true,
      changing: false,
      apiSerchString: '',
      serchCompanyData: {},
      checkedTag: '',
    }
  },
  methods: {
    show: async function(radish) {
      this.radish = radish
      this.apiSerchString = radish.公司
      this.qichachaSerch(radish.公司)
      this.dialogVisible = true
    },
    async qichachaSerch(companyName) {
      this.initvisible()
      this.qichachaResult = []
      const result = await window.app.service('company').apiSerchCompanyName(companyName)
      if (result.status === 'success') {
        this.qichachaResult = result.data.map(val => ({ value: val.value, type: val.type === '存在' ? 'danger' : '', company: val.company }))
      } else {
        this.qichachaResult = []
        this.$message(result.msg)
      }
    },
    init() {
      for (const key in this.company) {
        this.company[key] = ''
      }
      this.couldInsert = true
    },
    initvisible() {
      this.chooseCompanyVisible = false
      this.insertCompanyVisible = false
      this.checkedTag = ''
    },
    insertCompany(obj) {
      this.initvisible()
      this.checkedTag = obj.value
      if (obj.type !== 'danger') {
        this.init()
        this.company['公司名称'] = obj.value
        this.insertCompanyVisible = true
      } else {
        this.chooseCompanyVisible = true
        this.serchCompanyData = obj.company
      }
    },
    async duplicate() {
      const result = await window.app.service('company').duplicate({ 简称: this.company.简称 })
      if (result == '重复') {
        this.$message({
          message: '该简称已在数据库中存在，请更换',
          type: 'warning',
        })
        this.couldInsert = false
      } else this.couldInsert = true
    },
    async saveCompany() {
      this.changing = true
      const { company, radish } = this
      const option = { company: company }
      const result = await window.app.service('company').insertCompany({
        company: this.company,
      })
      if (result.status == 200) {
        if (company.公司名称 !== radish.公司 && company.简称 !== radish.公司) {
          const res = await app.service('company').insertCompanyAlias({
            公司: company.简称,
            别名: this.radish['公司'],
          })
        }
        this.$message('添加成功')
        this.radishListLoadData()
        this.dialogVisible = false
      } else {
        this.$message(result.msg)
      }
      this.changing = false
    },
    saveCom: async function() {
      this.changing = true
      const res = await app.service('radish').modifyById({
        _id: this.radish._id,
        data: { 公司: this.serchCompanyData.简称 },
      })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
        app.root.$refs.main &&
          app.root.$refs.main.$refs.radishList &&
          app.root.$refs.main.$refs.radishList.loadOne(this.radish._id)
        app.root.$refs.main &&
          app.root.$refs.main.$refs.radishListPro &&
          app.root.$refs.main.$refs.radishListPro.loadOne(this.radish._id)
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg)
      }
      this.changing = false
    },
    async saveAllCom() {
      const res = await app.service('radish').modify({
        query: { 公司: this.radish.公司 },
        data: { 公司: this.serchCompanyData.简称 },
      })
      if (res.status == 'success') this.radishListLoadData()
    },
    saveAlia: async function() {
      this.changing = true
      const res = await app.service('company').insertCompanyAlias({
        公司: this.serchCompanyData.简称,
        别名: this.radish['公司'],
      })
      if (res.status == 200) {
        this.radishListLoadData()
      } else if (res.status == 201) {
        this.saveAllCom()
      }
      this.changing = false
      this.dialogVisible = false
    },
    async consfirmUpdateAllRadish() {
      const res = await window.app.service('radish').countRadishes({ 公司: this.radish.公司 })
      if (res.status !== 'success') {
        this.$message(res.msg)
        return
      }
      this.$confirm(
        `数据库中一共有${res.data}名候选人公司为<span style="color: #f56c6c;">${
          this.radish.公司
        }</span>，是否将<span style="color: #f56c6c;">${this.radish.公司}</span>设置为<span style="color: #f56c6c;">${
          this.checkedTag
        }</span>的简称（${this.serchCompanyData.简称}）`,
        '提示',
        {
          confirmButtonText: '修改所有',
          cancelButtonText: '修改当前',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        },
      )
        .then(() => {
          this.consfirmInsertAlias()
        })
        .catch(() => {
          this.saveCom()
        })
    },
    consfirmInsertAlias() {
      this.$confirm(
        `是否同时将<span style="color: #f56c6c;">${this.radish.公司}</span>设置为<span style="color: #f56c6c;">${
          this.checkedTag
        }</span>的别名`,
        '提示',
        {
          confirmButtonText: '增加别名',
          cancelButtonText: '不用了',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        },
      )
        .then(() => {
          this.saveAlia()
        })
        .catch(() => {
          this.saveAllCom()
        })
    },
    radishListLoadData() {
      app.root.$refs.main && app.root.$refs.main.$refs.radishList && app.root.$refs.main.$refs.radishList.loadData()
    },
    addNewCompany: function() {
      window.open(`${window.origin}/#/NewAddCompany`, '_blank')
      this.dialogVisible = false
    },
    close: function() {
      this.apiSerchString = ''
    },
  },
}
</script>
<style scoped>
.half {
  width: 50%;
  float: left;
}
.clear-float {
  clear: both;
  width: 100%;
  height: 20px;
}
.waring {
  color: #e6a23c;
}
.dialog-footer {
  margin: 15px 0 6px;
}
.redword {
  color: #f56c6c;
}
.blueword {
  color: #409eff;
}
.dialog-company-tag:hover,
.company-tag-highlight {
  color: #00c1de;
  cursor: pointer;
}
</style>
